import { useTranslation } from 'react-i18next'
import LoadingIndicator from '@/widgets/LoadingIndicator'
import ProjectDetailsCard from './ProjectDetailsCard'
import ProjectStepsSection from './ProjectStepsSection'
import ProjectStepEditor from './ProjectStepEditor'
import ProjectCommonFieldsSection from './ProjectCommonFieldsSection'
import ProjectProofFilesSection from './ProjectProofFilesSection'
import useProjectDetailsPage from './hooks/useProjectDetailsPage'

export default function ProjectDetails() {
	const { t } = useTranslation()
	const {
		project,
		loading,
		createdDate,
		savingCommon,
		savingStep,
		stepEditorOpen,
		stepEditorKey,
		editingStep,
		previousStepForEditor,
		certificationOptions,
		saveCommonFields,
		openAddStep,
		openEditStep,
		openAddNextDayStep,
		closeStepEditor,
		saveStep,
		removeStep,
		uploadProjectFile,
		downloadProjectFile,
		deleteProjectFile,
	} = useProjectDetailsPage()

	if (loading) {
		return <LoadingIndicator message={t('projects.details.loading')} />
	}

	if (!project) {
		return <div className="min-h-screen flex items-center justify-center">{t('projects.details.noData')}</div>
	}

	return (
		<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
			<ProjectDetailsCard
				project={project}
				createdDate={createdDate}
			/>

			<ProjectStepsSection
				steps={project.steps}
				onAdd={openAddStep}
				onEdit={openEditStep}
				onAddNextDay={openAddNextDayStep}
				onRemove={removeStep}
			/>

			<ProjectCommonFieldsSection
				key={`${project._id}-${project.opis || ''}`}
				opis={project.opis}
				onSave={saveCommonFields}
				saving={savingCommon}
			/>

			<ProjectProofFilesSection
				project={project}
				onUploadProjectFile={uploadProjectFile}
				onDownloadProjectFile={downloadProjectFile}
				onDeleteProjectFile={deleteProjectFile}
			/>

			{stepEditorOpen ? (
				<ProjectStepEditor
					key={stepEditorKey}
					step={editingStep}
					projectTitle={project.nazwa}
					previousStep={previousStepForEditor}
					certificationOptions={certificationOptions}
					onSave={saveStep}
					onClose={closeStepEditor}
					submitting={savingStep}
				/>
			) : null}
		</div>
	)
}
